export const useIsTouchDevice = () =>
  window.matchMedia("(hover: none) and (pointer: coarse)").matches;
